import {LocaleHistory} from 'models/locale-history';
import {LocaleStats} from 'models/locale-stats';

import {SeoApp} from 'models/seo-app';
import {SeoAppAudio} from 'models/seo-app-audio';
import {SeoAppLanguage} from 'models/seo-app-language';
import {SeoAppSync} from 'models/seo-app-sync';

import {SeoLocale} from 'models/seo-locale';
import {SeoLocaleCategory} from 'models/seo-locale-category';
import {SeoLocaleContent} from 'models/seo-locale-content';
import {SeoLocaleKey} from 'models/seo-locale-key';
import {Audio} from '../../models/audio';
import {SeoLocaleKeyHints} from '../../models/seo-locale-key-hint';
import {Agent, Query, request} from './base';

export class SeopagesAgent {
    apps = new Agent(SeoApp, '/seopages/apps');
    audios = new Agent(Audio, '/seopages/audios');
    appsAudios = new Agent(SeoAppAudio, '/seopages/apps/audios');
    appLanguages = new Agent(SeoAppLanguage, '/seopages/apps/languages');

    localeKeys = new Agent(SeoLocaleKey, '/seopages/locales/keys');
    localeKeyHints = new Agent(SeoLocaleKeyHints, '/seopages/locales/keys/hints');
    localeContent = new Agent(SeoLocaleContent, '/seopages/locales/content');
    localeCategories = new Agent(SeoLocaleCategory, '/seopages/locales/categories');

    createApp = async (name: string, targetLanguageId: number, nationalityWordId?: number) => {
        return request.post('/seopages/apps', {
            name, targetLanguageId, nationalityWordId,
        });
    };

    getLocales = async ({appId, categoryId, motherLangId, targetLangId}: {
        appId: number;
        categoryId: number;
        motherLangId: number;
        targetLangId: number;
    }) => {
        const res = await request.get('/seopages/locales', {
            appId,
            categoryId,
            motherLangId,
            targetLangId,
        }) as SeoLocale[];
        return res.map(el => new SeoLocale(el));
    };

    getSyncStatus = async (query?: Query) => {
        const res = await request.get('/seopages/apps/sync', query) as SeoAppSync[];
        return res.map(el => new SeoAppSync(el));
    };

    sync = async () => {
        return request.post('/seopages/apps/sync', {});
    };

    syncAll = async () => {
        return request.post('/seopages/apps/sync/all', {});
    };

    syncOne = async (appId: number, categoryId: number, languageId: number, localeContentIds: number[]) => {
        return request.post('/seopages/apps/sync/one', { appId, categoryId, languageId, locales: localeContentIds });
    };

    getLocaleStats = (languageId: number, appId?: number, categoryId?: number) => {
        let url = `/locales/stats/seopages/${languageId}`;

        if (appId) {
            url += '/' + appId;

            if (categoryId) {
                url += '/' + categoryId;
            }
        }

        return request.get(url) as Promise<LocaleStats>;
    };

    getLocaleHistory = async (contentId: number) => {
        const res = await request.get('/locales/history/seopages/' + contentId) as LocaleHistory[];
        return res.map(el => new LocaleHistory(el));
    };

    setOutdated = async (id: number) => {
        return request.patch(`/seopages/locales/content/outdated/${id}`, {});
    };

    setOutdatedAll = async (keyId: number, appId: number, exceptionId: number) => {
        return request.patch(`/seopages/locales/content/outdated/${keyId}/${appId}/${exceptionId}`, {});
    };
}